module.exports = __webpack_public_path__ + "files/25c854816d934ae1347ebaecee300101.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/roboto-bold-webfont.woff
 ** module id = 996
 ** module chunks = 0
 **/